import { createRouter, createWebHistory } from "vue-router";
import SignIn from "../views/SignIn.vue";
import Dashboard from "../views/dashboard/index.vue";
import Test from "../views/Test.vue";
import ResetPassword from "../views/ResetPassword.vue"
import SettingDiscount from "../views/setting/Discount.vue";
import DiscountList from "../views/setting/discounts/DiscountList.vue";
import DiscountDetail from "../views/setting/discounts/DiscountDetail.vue";
import VoucherList from "../views/setting/vouchers/VoucherList.vue";
import VoucherDetail from "../views/setting/vouchers/VoucherDetail.vue";
import VoucherBundleList from "../views/setting/vouchers/VoucherBundleList.vue";
import VoucherBundleDetail from "../views/setting/vouchers/VoucherBundleDetail.vue";
import StoreList from "../views/setting/stores/StoreList.vue";
import StoreDetail from "../views/setting/stores/StoreDetail.vue";
import PhysicalBranchList from "../views/setting/physical-branches/PhysicalBranchList.vue";
import SettingGeneral from "../views/setting/General.vue";
import SettingsExportImport from "../views/setting/SettingsExportImport.vue";
import KioskSettingGeneral from "../views/setting/kiosk/General.vue";
import GrabFoodSettingGeneral from "../views/setting/grabfood/General.vue";
import PosSettingGeneral from "../views/setting/pos/General.vue";
import SettingCashback from "../views/setting/Cashback.vue";
import PointCashback from "../views/setting/Point.vue";
import SettingTier from "../views/setting/Tier.vue";
import TopUpListSetting from "../views/setting/topup/TopUpList.vue";
import CampaignList from "../views/campaigns/CampaignList.vue";
import CampaignDetail from "../views/campaigns/CampaignDetail.vue";
import ProductList from "../views/products/List.vue";
import ProductDetail from "../views/products/ProductDetail.vue";
import SettingSlide from "../views/setting/Slide.vue";
import MemberList from "../views/members/MemberList.vue"
import MemberDetailModern from "../views/members/MemberDetailModern.vue"
import ProductGroup from "../views/products/Group.vue";
import PaymentList from "../views/payments/PaymentList";
import AirwallexBalance from "../views/payments/AirwallexBalance.vue";
import SubscriptionList from "../views/subscription/SubscriptionList";
import ViewReportMonthSubscriptionList from "../views/subscription/ViewReportMonthSubscriptionList";
import ViewReportMonthSubscriptionInvoiceList from "../views/subscription/ViewReportMonthSubscriptionInvoiceList";
import DashboardReportList from "../views/dashboardreports/DashboardReportList.vue";
import SlideShowReport from "../views/dashboardreports/SlideShowReport.vue";
import TopUpReport from "../views/dashboardreports/TopUpReport.vue";
import ExpiryReport from "../views/dashboardreports/ExpiryReport.vue";
import DailyPaymentSummaryReport from "../views/dashboardreports/DailyPaymentSummaryReport.vue";
import UnUploadedReceiptReport from "../views/dashboardreports/UnUploadedReceiptReport.vue";
import VoidTopUpReport from "../views/dashboardreports/VoidTopUpReport.vue";
import PosTransactionReport from "../views/dashboardreports/PosTransactionReport.vue";
import TransactionByBranchReport from "../views/dashboardreports/TransactionByBranch.vue";
import PaidMembershipReport from "../views/dashboardreports/PaidMembershipReport.vue";
import MemberVoucherReport from "../views/dashboardreports/MemberVoucherReport.vue";
import OnlineOrderingReport from "../views/dashboardreports/OnlineOrderingReport.vue";
import KioskReport from "../views/dashboardreports/KioskReport.vue";
import SmsSetup from "../views/setting/sms/SmsSetup.vue";
import EmailSetup from "../views/setting/email/EmailSetup.vue";
import CreateEmailSetup from "../views/setting/email/CreateEmail.vue";
import SmsPaymentHistory from "../views/setting/sms/SmsPaymentHistory.vue";
import WaPaymentHistory from "../views/setting/sms/WaPaymentHistory.vue";
import checkModule from './middleware';
import MenuSet from "../views/menu/MenuSet.vue";
import Modifiers from "../views/menu/Modifiers.vue";
import ItemsMaster from "../views/menu/ItemsMaster.vue";
import OptionGroup from "../views/menu/OptionGroup.vue";
import ItemList from "../views/menu/ItemList.vue";
import CreateItem from "../views/menu/CreateItem.vue";
import CreateCombo from "../views/menu/CreateCombo.vue";
import ItemListByBranch from "../views/menu/ItemListByBranch.vue";
import BulkPriceHistory from "../views/menu/BulkPriceHistory.vue";
import ReportGroup from "../views/menu/ReportGroup.vue";
import Export from "../views/menu/Export.vue";
import Import from "../views/menu/Import.vue";
import ImportJson from "../views/menu/ImportJson.vue";
import BulkVoucherIssuanceList from "../views/bulkvoucher/BulkVoucherIssuanceList.vue";
import BulkVoucherIssuanceGenerateVoucher from "../views/bulkvoucher/BulkVoucherIssuanceGenerateVoucher.vue";
import OrderItemReport from "../views/dashboardreports/OrderItemReport.vue";
import WalletReport from "../views/dashboardreports/WalletReport.vue";
import MemberBalancePointsReport from "../views/dashboardreports/MemberBalancePointsReport.vue";
import PointReport from "../views/dashboardreports/PointReport.vue";
import WaMessageReport from "../views/dashboardreports/WaMessageReport.vue";
import DonationReport from "../views/dashboardreports/DonateReport.vue";
import TemplateList from "../views/marketing/templates/TemplateList.vue";
import MKT_CampaignDetail from "../views/marketing/campaigns/CampaignDetail.vue"
import MKT_TemplateDetail from "../views/marketing/templates/TemplateDetail.vue"
import BookingManagement from "../views/booking/bookingManagement.vue"
import AppointmentCalendar from "../views/booking/appointmentCalendar.vue"
import Stock from "../views/stock/Stock.vue";
import StockByPhysicalBranch from "../views/stock/StockByPhysicalBranch.vue";
import Order from "../views/order/OrderManagement.vue";
import QRGenerating from "../views/qr/index.vue";
import QueueQRGenerating from "../views/queue-qr/index.vue";
import Printers from "../views/menu/Printers.vue";
import DailyCollectionsReport from "../views/analytics/DailyCollectionsReport.vue";
import CollectionByBranchReport from "../views/analytics/CollectionByBranchReport.vue";
import ItemSalesByReceiptReport from "../views/analytics/ItemSalesByReceiptReport.vue";
import ItemSalesReport from "../views/analytics/ItemSalesReport.vue";
import ItemSalesWithModifiersReport from "../views/analytics/ItemSalesWithModifiersReport.vue";
import HourlySalesByBranchReport from "../views/analytics/HourlySalesByBranchReport.vue";
import PricingAnalysisReport from "../views/analytics/PricingAnalysisReport.vue";
import StaffClockInOutReport from "../views/analytics/StaffClockInOutReport.vue";
import DailyRevenueReport from "../views/analytics/DailyRevenueReport.vue";
import ItemSalesDetailReport from "../views/analytics/ItemSalesDetailReport.vue";
import ReportBuilderList from "../views/analytics/report-builder/ReportBuilderList.vue";
import ReportBuilderEditor from "../views/analytics/report-builder/ReportBuilderEditor.vue";
import ReportBuilderView from "../views/analytics/report-builder/ReportBuilderView.vue";
import CommissionReport from "../views/analytics/CommissionReport.vue";
import ServiceProductCommissionReport from "../views/analytics/ServiceProductCommissionReport.vue";
import ItemPerformance from "../views/business-insight/ItemPerformance.vue";
import HourlySalesHeatmap from "../views/business-insight/HourlySalesHeatmap.vue";
import AllOutletTotalRevenue from "../views/business-insight/AllOutletTotalRevenue.vue";
import ItemDetailsByChannel from "../views/analytics/ItemDetailsByChannelReport.vue";
import RecipeUsageReport from "../views/analytics/RecipeUsageReport.vue";
import ItemSalesByPrice from "../views/analytics/ItemSalesByPriceReport.vue";
import ProductionReport from "../views/analytics/ProductionReport.vue";
import CategorySalesReport from "../views/analytics/CategorySalesReport.vue";
import PosDailyCollectionsReport from "../views/analytics/PosDailyCollectionsReport.vue";
import ItemSalesByGroupDailyReport from "../views/analytics/ItemSalesByGroupDailyReport.vue";
import ERPCollectionsReport from "../views/erp/ErpCollectionsReport.vue";
import CallBackXero from "../views/erp/CallBackXero.vue";
import QuickBooksCallBack from "../views/erp/QuickBooksCallBack.vue";
import ERPInvoice from "../views/erp/ErpInvoice.vue";
import ERPDraft from "../views/erp/ErpDraft.vue";
import LoginCredentials from "../views/erp/LoginCredentials.vue";
import StripeReader from "../views/reader/index.vue";
import BranchComparison from "../views/business-insight/BranchComparison.vue";
import DailySalesSummary from "../views/business-insight/DailySalesSummary.vue";
import ItemAnalytics from "../views/business-insight/ItemAnalytics.vue";
import ItemSalesModifiersReport from "../views/analytics/ItemSalesModifiersReport.vue";
import ItemSalesModifiersReportNew from "../views/analytics/ItemSalesModifiersReportNew.vue";
import ItemDiscountReport from "../views/analytics/discount&foc/ItemDiscountReport.vue";
import BillDiscountReport from "../views/analytics/discount&foc/BillDiscountReport.vue";
import ItemFocReport from "../views/analytics/discount&foc/ItemFocReport.vue";
import BillFocReport from "../views/analytics/discount&foc/BillFocReport.vue";
import Inventory from "../views/inventory/index.vue";
import StockTransfer from "../views/inventory/StockTransfer.vue";
import StockInOut from "../views/inventory/StockInOut.vue";
import StockTransfers from "../views/inventory/StockTransfers.vue";
import StockTransferByPhysicalBranch from "../views/inventory/StockTransferByPhysicalBranch.vue";
import StockMovementSummaryReport from "../views/inventory/StockMovementSummaryReport.vue";
import BillVoidedReport from "../views/analytics/discount&foc/BillVoidedReport.vue";
import ItemVoidedReport from "../views/analytics/discount&foc/ItemVoidedReport.vue";
import PromoCodeList from "../views/promo-code/PromoCodeList.vue";
import PromoCodeDetail from "../views/promo-code/PromoCodeDetail.vue";
import PickupItemsReport from "../views/dashboardreports/PickupItemsReport.vue";

const routes = [
  {
    path: "/",
    redirect: "/sign-in",
  },
  {
    path: "/home",
    name: "Dashboard",
    component: Dashboard,
    beforeEnter: checkModule
  },
  {
    path: "/test",
    name: "Test",
    component: Test,
    beforeEnter: checkModule
  },
  {
    path: "/sign-in",
    name: "SignIn",
    component: SignIn,
  },
  {
    path: "/reset-password/:token?",
    name: "ResetPassword",
    component: ResetPassword,
  },
  {
    path: "/dashboard-reports",
    name: "DashboardReportList",
    component: DashboardReportList,
    beforeEnter: checkModule
  },
  {
    path: "/general-setting",
    name: "SettingGeneral",
    component: SettingGeneral,
    beforeEnter: checkModule
  },
  {
    path: "/settings-export-import",
    name: "SettingsExportImport",
    component: SettingsExportImport,
    beforeEnter: checkModule
  },
  {
    // Where the screen used to live, under General. Kept so a bookmark still lands.
    path: "/general-setting/import-json",
    redirect: "/settings-export-import"
  },
  {
    path: "/kiosk-general-setting",
    name: "KioskSettingGeneral",
    component: KioskSettingGeneral,
    beforeEnter: checkModule
  },
  {
    path: "/grabfood-general-setting",
    name: "GrabFoodSettingGeneral",
    component: GrabFoodSettingGeneral,
    beforeEnter: checkModule
  },
  {
    path: "/pos-general-setting",
    name: "PosSettingGeneral",
    component: PosSettingGeneral,
    beforeEnter: checkModule
  },
  {
    path: "/cashback-setting",
    name: "SettingCashback",
    component: SettingCashback,
    beforeEnter: checkModule
  },
  {
    path: "/point-setting",
    name: "SettingPoint",
    component: PointCashback,
    beforeEnter: checkModule
  },
  {
    path: "/discount-setting",
    name: "SettingDiscount",
    component: SettingDiscount,
  },
  {
    path: "/discounts",
    name: "DiscountList",
    component: DiscountList,
    beforeEnter: checkModule
  },
  {
    path: "/discount/:id?",
    name: "DiscountDetail",
    component: DiscountDetail
  },
  {
    path: "/vouchers",
    name: "VoucherList",
    component: VoucherList,
    beforeEnter: checkModule
  },
  {
    path: "/bulk-voucher-issuance",
    name: "BulkVoucherIssuance",
    component: BulkVoucherIssuanceList,
    beforeEnter: checkModule
  },
  {
    path: "/bulk-voucher-issuance-generate-voucher/:id",
    name: "BulkVoucherIssuanceGenerateVoucher",
    component: BulkVoucherIssuanceGenerateVoucher,
    beforeEnter: checkModule
  },
  {
    path: "/voucher/:id?",
    name: "VoucherDetail",
    component: VoucherDetail
  },
  {
    path: "/vouchers-bundle",
    name: "VoucherBundleList",
    component: VoucherBundleList,
    beforeEnter: checkModule
  },
  {
    path: "/voucher-bundle/:id?",
    name: "VoucherBundleDetail",
    component: VoucherBundleDetail
  },
  {
    path: "/promo-codes",
    name: "PromoCodeList",
    component: PromoCodeList
  },

  {
    path: "/promo-code/:id?",
    name: "PromoCodeDetail",
    component: PromoCodeDetail
  },
  {
    path: "/branches",
    name: "StoreList",
    component: StoreList,
    beforeEnter: checkModule
  },
  {
    // M1084: Testing Account flag per physical branch; same module as Sales Channel.
    path: "/physical-branches",
    name: "PhysicalBranchList",
    component: PhysicalBranchList,
    beforeEnter: checkModule
  },
  {
    path: "/branch/:id?",
    name: "StoreDetail",
    component: StoreDetail
  },
  {
    path: "/top-up",
    name: "TopUpListSetting",
    component: TopUpListSetting,
    beforeEnter: checkModule
  },
  {
    path: "/tier-setting",
    name: "SettingTier",
    component: SettingTier,
    beforeEnter: checkModule
  },
  {
    path: "/slide-setting",
    name: "SettingSlide",
    component: SettingSlide,
    beforeEnter: checkModule
  },
  {
    path: "/campaigns",
    name: "CampaignList",
    component: CampaignList,
    beforeEnter: checkModule
  },
  {
    path: "/campaign/:id?",
    name: "CampaignDetail",
    component: CampaignDetail
  },
  {
    path: "/menu-set",
    name: "MenuSet",
    component: MenuSet,
  },
  {
    path: "/modifiers",
    name: "Modifiers",
    component: Modifiers,
  },
  {
    path: "/items",
    name: "ItemsMasterList",
    component: ItemsMaster,
  },
  {
    path: "/option-group",
    name: "Option Group",
    component: OptionGroup,
  },
  {
    path: "/create-item",
    name: "Create Item",
    component: CreateItem,
  },
  {
    path: "/edit-item/:id",
    name: "Edit Item",
    component: CreateItem,
  },
  {
    path: "/create-combo",
    name: "Create Combo",
    component: CreateCombo,
  },
  {
    path: "/edit-combo/:id",
    name: "Edit Combo",
    component: CreateCombo,
  },
  {
    path: "/products",
    name: "ProductList",
    component: ProductList,
    beforeEnter: checkModule
  },
  {
    path: "/product/:id?",
    name: "ProductDetail",
    component: ProductDetail
  },
  {
    path: "/members",
    name: "MemberList",
    component: MemberList,
    beforeEnter: checkModule
  },
  {
    path: "/member/:id?",
    name: "MemberDetailModern",
    component: MemberDetailModern
  },
  {
    path: "/group",
    name: "ProductGroup",
    component: ProductGroup,
    beforeEnter: checkModule
  },
  {
    path: "/payments",
    name: "PaymentList",
    component: PaymentList,
    beforeEnter: checkModule
  },
  {
    path: "/airwallex-balance",
    name: "AirwallexBalance",
    component: AirwallexBalance,
    beforeEnter: checkModule
  },
  {
    path: "/subscriptions",
    name: "SubscriptionList",
    component: SubscriptionList,
    beforeEnter: checkModule
  },
  {
    path: "/view-report-month-subscriptions",
    name: "ViewReportMonthSubscriptionList",
    component: ViewReportMonthSubscriptionList,
  },
  {
    path: "/view-report-subscriptions-invoice/:id?",
    name: "ViewReportMonthSubscriptionInvoiceList",
    component: ViewReportMonthSubscriptionInvoiceList,
  },
  {
    path: "/dashboard-reports-slides-show",
    name: "DashboardReportSlidesShow",
    component: SlideShowReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-top-up",
    name: "DashboardReportTopUp",
    component: TopUpReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-expiry",
    name: "DashboardReportExpiry",
    component: ExpiryReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-daily-payment-summary",
    name: "DashboardDailyPaymentSummary",
    component: DailyPaymentSummaryReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-un-uploaded-receipts",
    name: "DashboardReportUnUploadedReceipt",
    component: UnUploadedReceiptReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-void-top-up",
    name: "DashboardReportVoidTopup ",
    component: VoidTopUpReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-pos-transaction",
    name: "DashboardReportPosTransaction",
    component: PosTransactionReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-transaction-by-branch",
    name: "TransactionByBranch",
    component: TransactionByBranchReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-paid-membership",
    name: "DashboardReportPaidMembership",
    component: PaidMembershipReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-member-voucher",
    name: "DashboardReportMemberVoucher",
    component: MemberVoucherReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-online-ordering",
    name: "DashboardReportOnlineOrdering",
    component: OnlineOrderingReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-kiosk",
    name: "DashboardReportKiosk",
    component: KioskReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-pickup-items",
    name: "PickupItemsReport",
    component: PickupItemsReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-wallet",
    name: "WalletReport",
    component: WalletReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-member-balance-points",
    name: "MemberBalancePointsReport",
    component: MemberBalancePointsReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-point",
    name: "PointReport",
    component: PointReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-wa-message",
    name: "WaMessageReport",
    component: WaMessageReport,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-donation",
    name: "DonationReport",
    component: DonationReport,
    beforeEnter: checkModule
  },
  {
    path: "/sms-and-wa-setup",
    name: "SmsSetup",
    component: SmsSetup,
    beforeEnter: checkModule
  },
  {
    path: "/sms-payment-history",
    name: "SmsPaymentHistory",
    component: SmsPaymentHistory,
  },
  {
    path: "/wa-payment-history",
    name: "WaPaymentHistory",
    component: WaPaymentHistory,
  },
  {
    path: "/item-list",
    name: "ItemList",
    component: ItemList,
  },
  {
    path: "/item-list-by-branch",
    name: "ItemListByBranch",
    component: ItemListByBranch,
  },
  {
    path: "/bulk-price-history",
    name: "BulkPriceHistory",
    component: BulkPriceHistory,
  },
  {
    path: "/report-group",
    name: "ReportGroup",
    component: ReportGroup,
  },
  {
    path: "/menu-set/printers",
    name: "Printers",
    component: Printers,
  },
  {
    path: "/menu-set/export",
    name: "Export",
    component: Export,
  },
  {
    path: "/menu-set/import",
    name: "Import",
    component: Import,
  },
  {
    path: "/menu-set/import-json",
    name: "ImportJson",
    component: ImportJson,
  },
  {
    path: "/email-setup",
    name: "EmailSetup",
    component: EmailSetup,
    beforeEnter: checkModule
  },
  {
    path: "/email-setup/create",
    name: "CreateEmailSetup",
    component: CreateEmailSetup,
    beforeEnter: checkModule
  },
  {
    path: "/email-setup/detail/:id",
    name: "EditEmailSetup",
    component: CreateEmailSetup,
    beforeEnter: checkModule
  },
  {
    path: "/dashboard-reports-order-item",
    name: "DashboardReportOrderItem",
    component: OrderItemReport,
    beforeEnter: checkModule
  },
  {
    path: "/booking/management",
    name: "BookingManagement",
    component: BookingManagement,
    beforeEnter: checkModule
  },
  {
    path: "/booking/calendar",
    name: "AppointmentCalendar",
    component: AppointmentCalendar,
    beforeEnter: checkModule
  },
  {
    path: "/marketing/wa-marketing-templates",
    name: "TemplateList",
    component: TemplateList,
    beforeEnter: checkModule
  },
  {
    path: "/marketing/wa-marketing-template/:id?",
    name: "MKT_TemplateDetail",
    component: MKT_TemplateDetail
  },
  {
    path: "/marketing/campaigns",
    name: "CampaignList",
    component: CampaignList,
    beforeEnter: checkModule
  },
  {
    path: "/marketing/campaign/:id?",
    name: "MKT_CampaignDetail",
    component: MKT_CampaignDetail
  },
  {
    path: "/analytics/daily-collections",
    name: "DailyCollectionsReport",
    component: DailyCollectionsReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/pos-daily-collections",
    name: "PosDailyCollectionsReport",
    component: PosDailyCollectionsReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/item-sales-by-group-daily",
    name: "ItemSalesByGroupDailyReport",
    component: ItemSalesByGroupDailyReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/collection-by-branch",
    name: "CollectionByBranchReport",
    component: CollectionByBranchReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/item-sales",
    name: "ItemSalesReport",
    component: ItemSalesReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/items-by-receipt",
    name: "ItemSalesByReceiptReport",
    component: ItemSalesByReceiptReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/item-sales-with-modifiers",
    name: "ItemSalesWithModifiersReport",
    component: ItemSalesWithModifiersReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/hourly-sales-by-branch",
    name: "HourlySalesByBranchReport",
    component: HourlySalesByBranchReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/pricing-analysis",
    name: "PricingAnalysisReport",
    component: PricingAnalysisReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/staff-clock-in-out",
    name: "StaffClockInOutReport",
    component: StaffClockInOutReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/daily-revenue",
    name: "DailyRevenueReport",
    component: DailyRevenueReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/item-sales-detail",
    name: "ItemSalesDetailReport",
    component: ItemSalesDetailReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/report-builder",
    name: "ReportBuilderList",
    component: ReportBuilderList,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/report-builder/new",
    name: "ReportBuilderNew",
    component: ReportBuilderEditor,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/report-builder/:id/edit",
    name: "ReportBuilderEdit",
    component: ReportBuilderEditor,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/report-builder/:id",
    name: "ReportBuilderView",
    component: ReportBuilderView,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/commission-report",
    name: "CommissionReport",
    component: CommissionReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/service-commission",
    name: "ServiceCommissionReport",
    component: ServiceProductCommissionReport,
    props: { reportType: "service" },
    beforeEnter: checkModule
  },
  {
    path: "/analytics/product-commission",
    name: "ProductCommissionReport",
    component: ServiceProductCommissionReport,
    props: { reportType: "product" },
    beforeEnter: checkModule
  },
  {
    path: "/analytics/item-details-by-channel",
    name: "ItemDetailsByChannel",
    component: ItemDetailsByChannel,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/recipe-usage",
    name: "RecipeUsageReport",
    component: RecipeUsageReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/item-sales-by-price",
    name: "ItemSalesByPrice",
    component: ItemSalesByPrice,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/production-report",
    name: "ProductionReport",
    component: ProductionReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/category-sales",
    name: "CategorySalesReport",
    component: CategorySalesReport,
    beforeEnter: checkModule
  },
  {
    path: "/business-insight/all-outlet-total-revenue",
    name: "AllOutletTotalRevenue",
    component: AllOutletTotalRevenue,
    beforeEnter: checkModule
  },
  {
    path: "/business-insight/item-performance",
    name: "ItemPerformance",
    component: ItemPerformance,
    beforeEnter: checkModule
  },
  {
    path: "/business-insight/hourly-sales-heatmap",
    name: "HourlySalesHeatmap",
    component: HourlySalesHeatmap,
    beforeEnter: checkModule
  },
  {
    path: "/business-insight/branch-comparison",
    name: "BranchComparison",
    component: BranchComparison,
    beforeEnter: checkModule
  },
  {
    path: "/business-insight/daily-sales-summary",
    name: "DailySalesSummary",
    component: DailySalesSummary,
    beforeEnter: checkModule
  },
  {
    path: "/business-insight/item-analytics",
    name: "ItemAnalytics",
    component: ItemAnalytics,
    beforeEnter: checkModule
  },
  {
    path: "/erp/pos-data-for-erp",
    name: "ERPCollectionsReport",
    component: ERPCollectionsReport,
    beforeEnter: checkModule
  },
  {
    path: "/erp/erp-invoice",
    name: "ERPInvoice",
    component: ERPInvoice,
    beforeEnter: checkModule
  },
  {
    path: "/erp/erp-draft",
    name: "ERPDraft",
    component: ERPDraft,
    beforeEnter: checkModule
  },
  {
    path: "/erp/login-credentials",
    name: "LoginCredentials",
    component: LoginCredentials,
    beforeEnter: checkModule
  },
  {
    path: "/branch/stock/:merchant_id/:branch_code",
    name: "Stock",
    component: Stock
  },
  {
    path: "/physical-branch/stock/:merchant_id/:branch_id",
    name: "StockByPhysicalBranch",
    component: StockByPhysicalBranch
  },
  {
    path: "/physical-branch/kds/:merchant_id(\\d+)/:branch_id(\\d+)/:printer_id(\\d+)/:status(preparing|ready)",
    name: "KdsDirectLink",
    component: StockByPhysicalBranch
  },
  {
    path: "/branch/orders/:merchant_id/:branch_code",
    name: "Order",
    component: Order
  },
  {
    path: "/qr/:merchant_id/:branch_code",
    name: "QRGenerating",
    component: QRGenerating
  },
  {
    path: "/queue-qr/:merchant_id/:branch_code",
    name: "QueueQRGenerating",
    component: QueueQRGenerating
  },
  {
    path: "/stripe-reader",
    name: "StripeReader",
    component: StripeReader
  },
  {
    path: "/analytics/item-sales-modifiers",
    name: "ItemSalesModifiersReport",
    component: ItemSalesModifiersReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/item-sales-modifiers-new",
    name: "ItemSalesModifiersReportNew",
    component: ItemSalesModifiersReportNew,
    beforeEnter: checkModule
  },
  {
    path: "/xero/callback",
    name: "CallBackXero",
    component: CallBackXero,
    beforeEnter: checkModule
  },
  {
    path: "/quickbooks/callback",
    name: "QuickBooksCallback",
    component: QuickBooksCallBack,
    beforeEnter: checkModule
  },
  {
    path: "/inventory",
    name: "Inventory",
    component: Inventory,
    beforeEnter: checkModule
  },
  {
    path: "/inventory/stock-in-out/:id?",
    name: "StockInOut",
    component: StockInOut,
    beforeEnter: checkModule
  },
  {
    path: "/inventory/stock-transfer/:id?",
    name: "StockTransfer",
    component: StockTransfer,
    beforeEnter: checkModule
  },
  {
    path: "/inventory/stock-transfers",
    name: "StockTransfers",
    component: StockTransfers,
    beforeEnter: checkModule
  },
  {
    path: "/physical-branch/stock-transfer/:merchant_id/:branch_id",
    name: "StockTransferByPhysicalBranch",
    component: StockTransferByPhysicalBranch
  },
  {
    path: "/inventory/stock-movement-summary-report",
    name: "StockMovementSummaryReport",
    component: StockMovementSummaryReport
  },
  {
    path: "/analytics/item-discount-report",
    name: "ItemDiscountReport",
    component: ItemDiscountReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/bill-discount-report",
    name: "BillDiscountReport",
    component: BillDiscountReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/item-foc-report",
    name: "ItemFocReport",
    component: ItemFocReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/bill-foc-report",
    name: "BillFocReport",
    component: BillFocReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/bill-voided-report",
    name: "BillVoidedReport",
    component: BillVoidedReport,
    beforeEnter: checkModule
  },
  {
    path: "/analytics/item-voided-report",
    name: "ItemVoidedReport",
    component: ItemVoidedReport,
    beforeEnter: checkModule
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

router.beforeEach((to) => {
  console.log(to)
})

export default router;
